import type { CanvasImage, ChatImageSlot } from './canvas-types';

/** Saved angle identity groups completed images; pending slots carry the same
 * identity so each concept keeps its place as its variants finish. */
export function chatImageGroups(slots: readonly ChatImageSlot[], images: readonly CanvasImage[]) {
  const byUrl=new Map(images.map(image=>[image.src,image]));
  const groups=new Map<string,ChatImageSlot[]>();
  for(const slot of [...slots].sort((a,b)=>a.index-b.index)){
    const image=slot.resolved?byUrl.get(slot.resolved):undefined;
    const key=slot.conceptKey ?? (image?.adAngleId!=null?`${image.workflowRunId ?? 'angles'}:${image.adAngleId}`:`slot:${slot.index}`);
    const group=groups.get(key) ?? [];group.push(slot);groups.set(key,group);
  }
  return Array.from(groups,([key,slots])=>({key,slots}));
}
